import { OyResponse } from '@oy/types';
import axios, { BUSINESS_PAYMENT_PREFIX } from 'src/clients/axios';
import { AskRefundPayload, WithdrawalInfo } from 'src/models';

export const postAskRefund = (data: AskRefundPayload) => {
  return axios.request({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}/channel/refund-balance`,
    data,
    headers: {
      'Content-Type': 'application/json',
    },
    disableToast: true,
  });
};

export const GET_WITHDRAWAL_INFO_URL = `${BUSINESS_PAYMENT_PREFIX}/channel/withdrawal-info`;

export const getWithdrawalInfo = () => {
  return axios.request<OyResponse<WithdrawalInfo>>({
    method: 'get',
    url: GET_WITHDRAWAL_INFO_URL,
  });
};
